<template>
    <div class="px-6 py-5 overflow-y-auto right-content-grid-vs h-[calc(100vh-309px)]">
        <div class="text-[#414141] font-sans">
            <h3 class="text-[1.25rem] leading-[1.75rem] mb-[1rem] font-semibold">Overview
            </h3>
            <p class="text-[14px] leading-[22px] mb-[0.5rem]">The <span class="font-bold">first step</span> in developing a successful strategic fundraising plan is to establish a clear understanding of your organization's annual operations, which includes core programs, budgets, and rationale.</p>
            
            <p class="text-[14px] leading-[22px] mb-[0.5rem]">This begins with articulating your <span class="font-bold">Core Annual Programs</span>, those ongoing initiatives that reflect your mission in action. These programs form the foundation of your work and should be described in a concise, consistent, and mission-aligned manner. Clarity at this level ensures internal alignment and provides a solid basis for future planning and external communication.</p>

            <p class="text-[14px] leading-[22px] mb-[0.5rem]">The <span class="font-bold">next step</span> is to clearly define your operating budget, including both programmatic and administrative expenses, as well as your revenue streams. A well-structured budget enhances internal decision-making, promotes financial transparency, and supports long-term sustainability.</p>

            <p class="text-[14px] leading-[22px] mb-[0.5rem]">The <span class="font-bold">last step</span> in this process is to develop a rationale for each of your Core Annual Programs.  Responses to nine (9) questions for each program will be requested.</p>

            <p class="text-[14px] leading-[22px] mb-[0.5rem]">This work will strengthen organizational coherence, improve strategic planning, and lay the groundwork for effective fundraising and stakeholder engagement.</p>
            
        </div>
    </div>
</template>

<script setup>
import { useStepValidation } from '@/composables/useStepValidation'; // Import the validation composable
// Use the validation composable with default settings
useStepValidation();
</script>

<style scoped>
</style> 